import Button from '../../Button'
import { Header } from '../../Modal'
import Box from '../../Modal/Box'
import Buttons from '../../Modal/Buttons'
import { Content } from '../../Modal/Content'
import { Container } from '../Container'

function ModalSizeXlCreate({ children }) {
  return (
    <Container label='Modal, create, size XL - 936px, max height - 560px'>
      <Box size='xl'>
        <Header text='Header text' variant='create' />
        <Content size='xl'>{children}</Content>
        <Buttons size='xl'>
          <Button.Contained height='32' text='Save' />
          <Button.Outlined height='32' text='Cancel' />
        </Buttons>
      </Box>
    </Container>
  )
}

export default ModalSizeXlCreate
